import { Theme } from '@mui/material'
import { useSelector } from 'react-redux'
import { RootState, store } from 'store'
import { TradeType } from 'store/market/types'
import { muiThemes, MuiThemeType } from 'styles/Themes'
import { defaultTif } from './reducer'
import {
  EFavoriteAssetsElements,
  MandatoryToastType,
  PreferenceType,
  TifType,
} from './types'
import { evmConnectionMeta } from '../../connection/meta'

export function useCurrentTheme(): Theme {
  // const themeType = useSelector<RootState, MuiThemeType>(
  //   (state) => state.settings.theme,
  // )
  // return muiThemes[themeType]
  return muiThemes[MuiThemeType.dark]
}
export function useCurrentThemeType(): MuiThemeType {
  return useSelector<RootState, MuiThemeType>((state) => state.settings.theme)
}
export function useCurrentConnectorName() {
  return evmConnectionMeta.getRecentConnectionMeta()?.type
}
export function useShowPortfolio() {
  return useSelector<RootState, boolean>(
    (state) => state.settings.showPortfolio,
  )
}
export function useSaveToken() {
  return useSelector<RootState, boolean>((state) => state.settings.save)
}
export function isSaveToken() {
  const state = store.getState()
  return state.settings.save
}

export function useMandatoryToast() {
  return useSelector<RootState, MandatoryToastType>(
    (state) => state.settings.mandatoryToast,
  )
}
export function useCurrentPlaceOrderTIF() {
  const currentTif = useSelector<RootState, Record<TradeType, TifType>>(
    (state) => state.settings.tif,
  )

  return currentTif ?? defaultTif
}
export function usePreferencesConfig() {
  return useSelector<RootState, PreferenceType>(
    (state) => state.settings.preferences,
  )
}

export function usePreference(key: keyof PreferenceType) {
  const preferences = usePreferencesConfig()
  return preferences ? preferences[key] : true
}

export function useFavoriteAssetsElements() {
  return useSelector<RootState, Array<EFavoriteAssetsElements>>(
    (state) => state.settings.favoriteAssetsElements,
  )
}
